<template>                    
    <form-helper>
        <div slot="form-header">
            
            <h2>Stammdaten</h2>                                                
            
        </div>
        
        <div slot="form-fields">
            <v-layout row>
                <v-flex xs8>
                    <v-text-field
                      name="name"
                      label="Name"
                      :error="errors.has('name')"
                      id="markename"
                      v-model="mk.name"
                      v-validate="'required|min:3'"
                      ></v-text-field>
                    <small class="small red--text" v-show="errors.has('name')">{{ errors.first('name') }}</small> 
                </v-flex>
            </v-layout> 
            <v-layout row>
                <v-flex xs12>
                    <firmen-select></firmen-select>
                </v-flex>
            </v-layout>    
            
        </div>
        
        <div slot="form-commands" >

            <v-btn icon v-on:click="submitted">
                <v-icon x-large class="green--text">done</v-icon>
            </v-btn>                        


            <router-link to="/marken" exact>
                <v-btn icon>
                    <v-icon x-large class="red--text">close</v-icon>
                </v-btn>
            </router-link>

        </div>
        
        
    </form-helper>



</template>

<script>
import formHelper from '../formHelper.vue'
import firmenSelect from '../shared/firmenSelect.vue'

export default {
    inject: ['$validator'],
    components: {
        'form-helper': formHelper,  
        'firmen-select': firmenSelect
    },
    data() {
        return {
            id: this.$route.params.id,               
        };
    },
    mounted(){
               
        this.$store.dispatch('setMarke', this.id)        
        this.$store.dispatch('setFirmen')                   
    },
    
    computed: {
        mk: function() {
            return this.$store.getters.marke
        },
        
        loading: function() {
            return this.$store.getters.loading
        },
        basePath: function() {
            return this.$axios.defaults.baseURL
        }, 

    },
    methods: {
        submitted: function() {
            this.$store.commit('setMessagebar', false)
            this.$validator.validateAll().then((result) =>{
               if(!result) {
                   this.$store.commit('setMessagebar',true)
                   return
               }
               this.$emit('submitted', this.mk)
            })
        },
                
        markenlogo: function(path) {
            return this.basePath + 'storage/logos/' + path;
        },              
    }
}
    
</script>

<style>
    
   
    
</style>


// WEBPACK FOOTER //
// editMarken_1.vue?147c39f5